export default "__VITE_ASSET__CLYjkHW2__"